'use client';
import { isNumber } from '@s7/utils';

let iid = 1;
const nextIID = ()=>iid++;
/**
 * Подписывает произвольный объект уникальным в рамках runtime ключом.
 * Используется, чтобы различать экземпляры однотипных объектов.
 * */ const signIID = (fn, rid)=>{
    fn.$$iid = rid;
    return fn;
};
const hasIID = (candidate)=>isNumber(candidate.$$iid);
const getIID = (candidate)=>candidate.$$iid;

export { getIID, hasIID, nextIID, signIID };
//# sourceMappingURL=iid.js.map
